<div class="toggle-switch" [ngClass]="{ disabled: disabled }">
  <mat-slide-toggle
    class="toggle-switch-button"
    (change)="onChange($event)"
    checked="{{ checked }}"
    [disabled]="disabled"
    [labelPosition]="labelPosition"
    [ngClass]="size"
  ></mat-slide-toggle>

  <div class="toggle-switch-caption" [ngClass]="{ disabled: disabled }" *ngIf="captionText">
    {{ captionText }}
  </div>
</div>
